<div class="navigation-breadcrumb">
    <ng-container *ngFor="let item of breadcrumbItems; let last = last">
        <ng-container *ngIf="item.link;">
            <a
                class="breadcrumb-text linkable"
                (click)="onBreadcrumbClick(item)"
            >
                {{ item.label }}
            </a>
        </ng-container>
        <ng-container *ngIf="!item.link || last">
            <span
                class="breadcrumb-text non-link"
                [class.current-page]="last"
            >
                {{ item.label }}
            </span>
        </ng-container>
        <span *ngIf="!last" class="breadcrumb-separator"> / </span>
    </ng-container>
</div>
